class VideoReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(
      this.querySelectorAll('.video-with-reviews__slide')
    );
    this.dots = Array.from(this.querySelectorAll('.video-with-reviews__dot'));
    this.index = 0;
    this.timer = null;
    this.interval = parseInt(this.dataset.interval, 10) || 5000;
    this.reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (this.slides.length < 2) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.slideIndex, 10));
        this.restart();
      });
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', (event) => {
      if (!this.contains(event.relatedTarget)) this.start();
    });

    if (window.Shopify && window.Shopify.designMode) {
      this.onBlockSelect = (event) => {
        const slideIndex = this.slides.indexOf(event.target);
        if (slideIndex > -1) {
          this.stop();
          this.goTo(slideIndex);
        }
      };
      this.onBlockDeselect = () => this.start();
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener(
        'shopify:block:deselect',
        this.onBlockDeselect
      );
    }

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    if (this.onBlockSelect) {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener(
        'shopify:block:deselect',
        this.onBlockDeselect
      );
    }
  }

  goTo(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.index);
      if (i === this.index) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
      if (i === this.index) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  start() {
    if (this.reducedMotion || this.timer) return;
    this.timer = setInterval(() => this.goTo(this.index + 1), this.interval);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    this.stop();
    this.start();
  }
}

if (!customElements.get('video-reviews-carousel')) {
  customElements.define('video-reviews-carousel', VideoReviewsCarousel);
}
